'use client';

import React from 'react';
import styled from '@emotion/styled';
import { theme } from '../../../styles/theme';
import SecurityWaitTimesWidget from '../../security/ui/SecurityWaitTimesWidget';
import { ContentWrap, Responsive } from '../../../ui';

export default function SecurityWaitTimesWidgetWrap() {
	return (
		<SecurityWidgetWrap>
			<SecurityWaitTimesWidget />
		</SecurityWidgetWrap>
	);
}

const SecurityWidgetWrap = styled.div`
	${ContentWrap} {
		display: grid;
		grid-column-gap: ${theme.grid?.gutter?.vertical?.default};
		grid-template-columns: 2fr 1fr;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: flex;
		justify-content: space-between;
	}
`;
